import script from "./NotificationBell.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationBell.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationBell.vue?vue&type=style&index=0&id=3e38d6f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e38d6f6"]])

export default __exports__